<app-action-button
  (addEvent)="create($event)"
  (deleteEvent)="openConfirm($event)"
    [hidden]="
        (!isDeleteAction && !authorizationService.canCreateNetworks()) ||
        (isDeleteAction && selectedNetworkIds.length > 1)
    "
  [isDeleteAction]="isDeleteAction"
  >
</app-action-button>

<app-loader [isLoading]="isLoading" id="networksPage"></app-loader>

<div class="area" id="ItemsArea">
  <div (click)="create(true)" [hidden]="showList || isLoading" class="noarea" id="NoArea">
    <div class="icon" style="background-image: url(/assets/svgs/No_Networks.svg)"></div>
    <div class="title">No v6 networks currently exist</div>
  </div>
  <div [hidden]="!showList || isLoading" id="ItemTable">
    <div
      [ngClass]="{ showNetworkGroupName: canListNetworkGroups, powerUser: featureService.powerUserEnabled }"
      class="tableGrid tHeadRow"
      >
      <div class="tHead">
        @if (hasSomeDeletePermission) {
          <div
            (click)="toggleAll()"
            [ngClass]="{ selected: allToggled }"
            class="tSelect all"
            id="ToggleAll"
          ></div>
        }
      </div>

      <div (click)="sort('name')" [ngClass]="getSortClass('name')" class="tHead sort">Name</div>

      @if (canListNetworkGroups) {
        <div [ngClass]="getSortClass('networkGroupName')" class="tHead sort">
          <span (click)="sort('networkGroupName')">{{ selectedNetworkGroupName }}</span>
          <div
            (click)="filtering('networkGroupName')"
            (clickOutside)="filteringBy === 'networkGroupName' && closeFilters()"
            class="filterButton"
            id="networkGroupFilter"
            >
            <div [ngClass]="{ open: filteringBy === 'networkGroupName' }" class="options">
              <div (click)="setNetworkGroupNameFilter('')" class="option">All Network Groups</div>
              @for (networkGroup of networkGroups; track networkGroup) {
                <div
                  (click)="setNetworkGroupNameFilter(networkGroup.id)"
                  class="option"
                  >
                  {{ networkGroup.name }}
                </div>
              }
            </div>
          </div>
        </div>
      }

      <div (click)="sort('statusLabel')" [ngClass]="getSortClass('statusLabel')" class="tHead sort">Status</div>
      <div (click)="sort('regionLabel')" [ngClass]="getSortClass('statusLabel')" class="tHead sort">Region</div>
      <div (click)="sort('sizeLabel')" [ngClass]="getSortClass('statusLabel')" class="tHead sort">Size</div>
      <div (click)="sort('version')" [ngClass]="getSortClass('version')" class="tHead sort">Version</div>
      @if (provisionedAt) {
        <div
          (click)="sort('provisionedAt')"
          [ngClass]="getSortClass('provisionedAt')"
          class="tHead sort"
          >
          Provisioned Date
        </div>
      }
      @if (!provisionedAt) {
        <div
          (click)="sort('createdAt')"
          [ngClass]="getSortClass('createdAt')"
          class="tHead sort"
          >
          Provisioned Date
        </div>
      }
      @if (featureService.powerUserEnabled) {
        <div class="tHead sort">ID</div>
      }

      <div class="thead tRight">
        @if (anyToggled()) {
          <div (click)="toggleMenu($event, -2)" class="dots" id="Dots_Bulk">
            ...
            <div (clickOutside)="closeActionMenu()" [ngClass]="{ open: -2 === openIndex }" class="tMenu one">
              <div (click)="downloadCsv($event)" class="tActionRow" id="DownloadCSV_Bulk">Download CSV</div>
            </div>
          </div>
        }
      </div>
    </div>
    <!-- end table headers -->

    <!-- begin table body -->
    <div id="ItemsList">
      @for (
        item of displayedItems
        | sortby: sorting:ordering
        | paginate
        : {
        itemsPerPage: pageSize,
        currentPage: page,
        totalItems: filterService.getTotalElements()
        }; track trackById(index,
        item); let index = $index) {
        <div
          [attr.data-index]="index"
          [ngClass]="{ showNetworkGroupName: canListNetworkGroups, powerUser: featureService.powerUserEnabled }"
          class="tableGrid tRow t{{ item.status }} "
          id="Item_{{ item.id }}"
          >
          <div class="tCol">
            @if (item.actionList.includes('delete')) {
              <div
                (click)="toggle(item)"
                [ngClass]="{ selected: item.selected }"
                class="tSelect"
                id="RowSelect0_{{ item.id }}"
              ></div>
            }
          </div>
          <div (click)="goToDashboard(item)" class="tCol clickCol padLabel" id="RowSelect1_{{ item.id }}">
            <div
              class="status s{{ item.status }}"
              data-id="{{ item.id }}"
              id="n{{ item.id }}"
              title="{{ item.statusLabel }}"
              >
              <div class="anim5"></div>
            </div>
            {{ item.name }}
          </div>
          @if (canListNetworkGroups) {
            <div
              (click)="goToDashboard(item)"
              class="tCol clickCol"
              id="RowSelect2_{{ item.id }}"
              >
              {{ item.networkGroupName }}
            </div>
          }
          <div (click)="goToDashboard(item)" class="tCol clickCol" id="RowSelect3_{{ item.id }}">
            {{ item.statusLabel }}
          </div>
          <div (click)="goToDashboard(item)" class="tCol clickCol" id="RowSelect3_{{ item.id }}">
            {{ item.region }}
          </div>
          <div (click)="goToDashboard(item)" class="tCol clickCol" id="RowSelect3_{{ item.id }}">
            {{ item.size }}
          </div>
          <div class="tCol clickCol" id="RowSelect4_{{ item.id }}">
            <span (click)="goToDashboard(item)">{{ item.version }}</span>
            @if (item.upgradeableVersions?.length > 0) {
              <button
                (click)="upgrade(item)"
                class="save alert confirm upgradebadge"
                >
                Upgrade
              </button>
            }
          </div>
          @if (item.provisionedAt) {
            <div
              (click)="goToDashboard(item)"
              class="tCol clickCol"
              id="RowSelect5_{{ item.id }}"
              >
              {{ formatTime(item['provisionedAt']) }}
            </div>
          }
          @if (!item.provisionedAt) {
            <div
              (click)="goToDashboard(item)"
              class="tCol clickCol"
              id="RowSelect5_{{ item.id }}"
              >
              {{ formatTime(item['createdAt']) }}
            </div>
          }
          @if (featureService.powerUserEnabled) {
            <div
              (click)="copy(item)"
              class="tCol clickCol"
              id="RowSelect5_{{ item.id }}"
              >
              {{ item.id }}
            </div>
          }
          <div class="tCol tRight">
            @if (item.actionList.length > 0) {
              <div
                (click)="toggleMenu($event, index)"
                class="dots"
                id="RowDots_{{ index }}"
                >
                ...
                <div (clickOutside)="closeActionMenu()" [ngClass]="{ open: index === openIndex }" class="tMenu">
                  @if (item.upgradeableVersions?.length > 0) {
                    <div
                      (click)="upgrade(item)"
                      class="tActionRow"
                      id="RowEdit_{{ index }}"
                      >
                      Upgrade Network
                    </div>
                  }
                  @if (item.actionList.includes('update')) {
                    <div
                      (click)="openRename(item)"
                      class="tActionRow"
                      id="RowEdit_{{ index }}"
                      >
                      Rename
                    </div>
                  }
                  @if (item.actionList.includes('json')) {
                    <div
                      (click)="openJson(item)"
                      class="tActionRow"
                      id="RowEdit_{{ index }}"
                      >
                      JSON
                    </div>
                  }
                  @if (item.actionList.includes('o365')) {
                    <div
                      (click)="o365Optimize(item)"
                      class="tActionRow"
                      id="RowOptimize_{{ index }}"
                      >
                      O365 Optimize
                    </div>
                  }
                  @if (item.actionList.includes('get')) {
                    <div
                      (click)="open(item)"
                      class="tActionRow"
                      id="RowDetails_{{ index }}"
                      >
                      Firewall Info
                    </div>
                  }
                  @if (item.actionList.includes('get')) {
                    <div
                      (click)="openNotification(item)"
                      class="tActionRow"
                      id="RowNotifications_{{ index }}"
                      >
                      Notifications
                    </div>
                  }
                  @if (item.actionList.includes('clientMfa')) {
                    <div
                      (click)="openClientMfaForm(item)"
                      class="tActionRow"
                      id="RowClientMFAConfig_{{ index }}"
                      >
                      Client Mfa Setup
                    </div>
                  }
                  @if (item.actionList.includes('exportYml')) {
                    <div
                      (click)="exportYML(item)"
                      class="tActionRow"
                      id="RowExportYML_{{ index }}"
                      >
                      Export YML
                    </div>
                  }
                  @if (item.actionList.includes('delete')) {
                    <div
                      (click)="confirmDelete(item)"
                      class="tActionRow"
                      id="RowDelete_{{ index }}"
                      >
                      Delete
                    </div>
                  }
                  @if (item.majorVersion >= 7) {
                    <div
                      (click)="confirmExport(item)"
                      class="tActionRow"
                      id="RowExport_{{ index }}"
                      >
                      Download
                    </div>
                  }
                  @if (authorizationService.isSupportUser() && item.status !== 'SUSPENDED') {
                    <div
                      (click)="suspend(item)"
                      class="tActionRow"
                      id="RowEdit_{{ index }}"
                      >
                      Suspend Network
                    </div>
                  }
                  @if (authorizationService.isSupportUser() && item.status === 'SUSPENDED') {
                    <div
                      (click)="resume(item)"
                      class="tActionRow"
                      id="RowEdit_{{ index }}"
                      >
                      Resume Network
                    </div>
                  }
                  @if (authorizationService.isSupportUser()) {
                    <div
                      (click)="restart(item)"
                      class="tActionRow"
                      id="RowEdit_{{ index }}"
                      >
                      Restart
                    </div>
                  }
                  @if (authorizationService.isSupportUser()) {
                    <div
                      (click)="resize(item)"
                      class="tActionRow"
                      id="RowEdit_{{ index }}"
                      >
                      Resize
                    </div>
                  }
                </div>
              </div>
            }
          </div>
        </div>
      }
    </div>
  </div>
</div>
